import { render, staticRenderFns } from "./ScoringPanelistsManager.vue?vue&type=template&id=5922fa90"
import script from "./ScoringPanelistsManager.vue?vue&type=script&lang=ts"
export * from "./ScoringPanelistsManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports